import { Button, DataTable } from "@/components";
import { RightWrapper } from "../../../components";
import { FaPlus } from "react-icons/fa6";
import { PickupAddressForm } from "../..";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import {
  fetchPickupAddresses,
  removePickupAddress,
  selectAllPickupAddresses,
} from "../../../app/slices/pickupAddressSlice";
import { useEffect, useMemo, useState } from "react";
import { getPickupAddressData } from "../../../utils/Data";
import ColumnHelper from "@/utils/ColumnHelper";
import { useDispatch, useSelector } from "react-redux";
import { useAlert } from "@/";

const PickupAddress = () => {
  const { alert, AlertDialog } = useAlert();
  const dispatch = useDispatch();
  const pickupAddresses = useSelector(selectAllPickupAddresses) || [];

  const [sheetOpen, setSheetOpen] = useState(false);
  const handleDelete = async (id) => {
    console.log(id);
    try {
      const response = await dispatch(removePickupAddress(id));

      if (removePickupAddress.fulfilled.match(response)) {
        console.log(
          "✅ Pickup Address Deleted Successfully:",
          response.payload
        );
        alert("✅ Pickup Address Deleted Successfully");
      } else if (removePickupAddress.rejected.match(response)) {
        const errorMsg = response.payload || "Failed to delete pickup address.";
        console.error("❌ Delete Failed:", errorMsg);
        alert(errorMsg);
      }
    } catch ({ error }) {
      console.error("❌ Unexpected Error:", error.message || error);
      alert("❌ Unexpected Error:", error.message);
    }
  };

  useEffect(() => {
    dispatch(fetchPickupAddresses());
  }, []);

  const isLoadingPickupAddress = useSelector(
    (state) => state.pickupAddress.loading
  );
  const columns = useMemo(
    () => [
      ColumnHelper({
        header: "Contact Name",
        accessorKey: "contactPerson", // Matches API response
        meta: {
          tooltip: (row) => row.contactPerson || "N/A",
        },
      }),
      ColumnHelper({
        header: "Mobile",
        accessorKey: "contactPhone", // Matches API response
        meta: {
          tooltip: (row) => row.contactPhone || "N/A",
        },
      }),
      ColumnHelper({
        header: "Pick Address",
        accessorKey: "fullAddress", // Matches API response
        meta: {
          tooltip: (row) => row.fullAddress || "N/A",
        },
      }),
      ColumnHelper({
        header: "City",
        accessorKey: "city",
        meta: {
          tooltip: (row) => row.city || "N/A",
        },
      }),
      ColumnHelper({
        header: "Pincode",
        accessorKey: "pincode",
        meta: {
          tooltip: (row) => row.pincode || "N/A",
        },
      }),
      ColumnHelper({
        header: "Actions",
        accessorKey: "id",
        cell: (info) => {
          const [rowSheetOpen, setRowSheetOpen] = useState(false);
          return (
            <div className="flex gap-1 justify-center items-center">
              <Sheet open={rowSheetOpen} onOpenChange={setRowSheetOpen}>
                <SheetTrigger asChild>
                  <Button size="xs">Edit</Button>
                </SheetTrigger>
                <SheetContent aria-describedby="">
                  <SheetHeader>
                    <SheetTitle> Edit Pickup Address</SheetTitle>
                  </SheetHeader>
                  <PickupAddressForm
                    setSheetOpen={rowSheetOpen}
                    data={info.row.original}
                    isEdit={true}
                  />
                </SheetContent>
              </Sheet>
              <Button
                size="xs"
                className="bg-red-500 text-white"
                onClick={() => handleDelete(info.row.original._id)}
              >
                Delete
              </Button>
            </div>
          );
        },
        meta: {
          tooltip: () => "Edit or delete employee record",
        },
      }),
    ],
    []
  );

  const data = useMemo(() => getPickupAddressData(100), []);
  return (
    <RightWrapper>
      <div className="flex flex-col gap-4 m-2 pb-20 md:pb-4">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row gap-4 justify-between items-end">
          <div className="flex flex-col gap-1 w-full">
            <h1 className="text-headline4 md:text-headline3 font-nunito text-secondary/95 font-semibold">
              Pickup Address
            </h1>
            <p className="text-body2 font-ptsans text-secondary/60 lg:w-[50%]">
              Easily manage multiple pickup locations for seamless order
              fulfillment and optimized courier allocation.
            </p>
          </div>

          {/* Add Pickup Address Button */}
          <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
            <SheetTrigger asChild>
              <Button variant="default" size="sm" icon={FaPlus}>
                Add Pickup Address
              </Button>
            </SheetTrigger>
            <SheetContent aria-describedby="">
              <SheetHeader>
                <SheetTitle>Add Pickup Address</SheetTitle>
              </SheetHeader>
              <PickupAddressForm setSheetOpen={setSheetOpen} />
            </SheetContent>
          </Sheet>
        </div>
        <DataTable
          columns={columns}
          tittle="Pickup Address"
          isLoading={isLoadingPickupAddress}
          data={pickupAddresses}
          showCheckbox={false}
        />
      </div>
      <AlertDialog />
    </RightWrapper>
  );
};

export default PickupAddress;
